import axios from "axios";

import { I18n } from "react-redux-i18n";
import {
  TRANSACTION_REQUEST_LIST_ATTEMPT,
  TRANSACTION_REQUEST_LIST_SUCCESS,
  TRANSACTION_REQUEST_LIST_FAILED,
  /////////////////////////////////////
  TRANSACTION_REQUEST_MORELIST_ATTEMPT,
  TRANSACTION_REQUEST_MORELIST_SUCCESS,
  TRANSACTION_REQUEST_MORELIST_FAILED,
  /////////////////////////////////
  TRANSACTION_REQUEST_NEW_SUCCESS,
  TRANSACTION_REQUEST_NEW_FAILED,
  ////////////////////////////////
  TRANSACTION_REQUEST_CALIFICATION_SUCCESS,
  TRANSACTION_REQUEST_CALIFICATION_FAILED,
} from "../types/transactionRequestPendingTypes";
import { shouldFetchList } from "../utils/shouldFetchList";
import { config } from "../../config";
const url_api = config.api.godiway;

export function loading() {
  return {
    type: TRANSACTION_REQUEST_LIST_ATTEMPT,
  };
}

export function success(data) {
  return {
    type: TRANSACTION_REQUEST_LIST_SUCCESS,
    data: data,
  };
}

export function failed(error) {
  return {
    type: TRANSACTION_REQUEST_LIST_FAILED,
    error: error,
  };
}

////////////////////////////////////////

export function loadingMore() {
  return {
    type: TRANSACTION_REQUEST_MORELIST_ATTEMPT,
  };
}

export function successMore(data) {
  return {
    type: TRANSACTION_REQUEST_MORELIST_SUCCESS,
    data: data,
  };
}

export function failedMore(error) {
  return {
    type: TRANSACTION_REQUEST_MORELIST_FAILED,
    error: error,
  };
}
//////////////////////////////////////////
export function successNewRequest(item) {
  return {
    type: TRANSACTION_REQUEST_NEW_SUCCESS,
    item: item,
  };
}

export function failedNewRequest(error) {
  return {
    type: TRANSACTION_REQUEST_NEW_FAILED,
    error: error,
  };
}
////////////////////////////////////////

export function successCalification(item) {
  return {
    type: TRANSACTION_REQUEST_CALIFICATION_SUCCESS,
    item: item,
  };
}

export function failedCalification(error) {
  return {
    type: TRANSACTION_REQUEST_CALIFICATION_FAILED,
    error: error,
  };
}

export const loadList = (data: Object) => async (dispatch, getState) => {
  if (!shouldFetchList(getState().transactionRequestPending)) {
    return;
  }

  dispatch(loading());
  await axios
    .get(url_api + "transaction/requestpending", {
      params: {
        id: data.user_id,
        lang: I18n.t("locale"),
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};

export const loadListScroll = (data: Object) => async (dispatch) => {
  dispatch(loadingMore());
  await axios
    .get(url_api + "transaction/requestpending", {
      params: {
        index: data.page_count,
        id: data.user_id,
        lang: I18n.t("locale"),
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(successMore(response.data.body));
        else dispatch(failedMore(response.data.body));
      } else {
        dispatch(failedMore("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failedMore("try_later"));
      } else {
        dispatch(failedMore("try_later"));
      }
      return;
    });
};

export const newItem = (data: Object) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: url_api + "transaction",
      data: data.params,
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(successNewRequest(response.data.body));
      return { success: true };
    }

    const error = response.data.body || "try_later";
    dispatch(failedNewRequest(error));
    return { success: false, error };
  } catch (error) {
    console.log(error);
    dispatch(failedNewRequest("try_later"));
    return { success: false, error: "try_later" };
  }
};

export const addCalification = (data: Object) => async (dispatch) => {
  // dispatch(loading());
  //console.log(data);
  await axios({
    method: "post",
    url: url_api + "calification",
    data: data.params,
    headers: { Authorization: `Bearer ${data.token}` },
  })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(successCalification(response.data.body));
        else dispatch(failedCalification(response.data.body));
      } else {
        dispatch(failedCalification("try_later"));
      }
    })
    .catch(function (error) {
      if (error.Error) {
        dispatch(failedCalification("try_later"));
      } else {
        dispatch(failedCalification("try_later"));
      }
      return;
    });
};
